import './Collezione.css';

const Collezione = () => {

  return (
    <div class="max-h-[calc(100vh-86px)] overflow-y-auto flex flex-col justify-between h-full">
        <main class="max-w-6xl mx-auto w-full px-4 py-8">
            <header class="text-center mb-8">
                <h1 class="text-3xl font-serif mb-2 tracking-wide">La Nuova Collezione</h1>
                <p class="text-stone-500 text-sm max-w-md mx-auto italic">Un'armonia di tessuti pregiati e dettagli fatti a mano.</p>
            </header>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div class="group cursor-pointer">
                    <div class="bg-stone-200 aspect-[3/4] mb-3 flex items-center justify-center text-stone-500 font-serif italic text-xs">Mockup Immagine 1</div>
                    <h3 class="font-serif text-base">Abito Fluido in Seta</h3>
                    <p class="text-stone-500 text-xs mt-0.5">€ 1.200</p>
                </div>
                <div class="group cursor-pointer">
                    <div class="bg-stone-200 aspect-[3/4] mb-3 flex items-center justify-center text-stone-500 font-serif italic text-xs">Mockup Immagine 2</div>
                    <h3 class="font-serif text-base">Giacca Strutturata Lino</h3>
                    <p class="text-stone-500 text-xs mt-0.5">€ 850</p>
                </div>
                <div class="group cursor-pointer">
                    <div class="bg-stone-200 aspect-[3/4] mb-3 flex items-center justify-center text-stone-500 font-serif italic text-xs">Mockup Immagine 3</div>
                    <h3 class="font-serif text-base">Pantalone a Palazzo</h3>
                    <p class="text-stone-500 text-xs mt-0.5">€ 540</p>
                </div>
            </div>
        </main>
    </div>
  );
};

export default Collezione;
